import { render, staticRenderFns } from "@/client/budget/views/acceptance/acceptance.pug?vue&type=template&id=0d28472a&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/client/budget/views/acceptance/acceptance.scss?vue&type=style&index=0&id=0d28472a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d28472a",
  null
  
)

export default component.exports